import { ShieldAlert, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MfaPanel } from "@/components/MfaDialog";

export function MfaEnrollGate() {
  const { user, refresh, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-10" data-testid="mfa-enroll-gate">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 mb-5">
          <ShieldAlert className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-amber-900">
            <div className="font-semibold">Authenticator app required</div>
            Your organization requires every staff member to sign in with an authenticator app. Set it up now to continue — it takes about a minute.
          </div>
        </div>
        <MfaPanel forced onEnrolled={refresh} />
        <div className="mt-5 flex items-center justify-between text-xs text-slate-500">
          <span data-testid="mfa-gate-user">{user?.email}</span>
          <button type="button" onClick={async () => { await logout(); nav("/login"); }} data-testid="mfa-gate-logout" className="inline-flex items-center gap-1 hover:text-slate-900"><LogOut className="h-3.5 w-3.5" /> Sign out</button>
        </div>
      </div>
    </div>
  );
}
